import styled from 'styled-components';

export const Field = styled.div`
  display: flex;
  padding: 0.6rem 0;
  border-radius: 3px;
  margin-left: ${(props) => props.theme.spacing['8px']};
`;

export const FieldLabel = styled.p`
  font-weight: bold;
  margin: 0;
  width: 13rem;
  flex-shrink: 0;
  color: ${({ theme }) => theme.colors.primary.blueDark};
`;

export const FieldValue = styled.p`
  color: ${({ theme }) => theme.colors.primary.blueDark};
  margin: 0;
`;
